@let images = imageStore.images;
@if (imageStore.isLoading()) {
  <div class="pt-32">
    <aw-loading-animation></aw-loading-animation>
  </div>
}
@if (images() && !imageStore.isLoading()) {
  <div class="flex flex-col gap-6">
    <!-- Header -->
    <div class="flex justify-between">
      <div class="flex flex-col gap-2">
        <span class="text-3xl" [attr.data-testid]="'section-header-headline'">
          <ng-content> {{ cmsTextProvider.shared.allImages }}</ng-content>
        </span>
        <span class="text-standard-text-secondary text-md">
          {{ cmsTextProvider.allImages.uploadInstruction }}
        </span>
      </div>
      <div class="flex gap-2">
        <aw-button
          [id]="'cancel-images'"
          [type]="'button'"
          [isDisabled]="!hasChanges"
          (click)="handleAbortChangesDialog()"
          [text]="cmsTextProvider.shared.cancel"
          [style]="'primary-alt'"></aw-button>
        <aw-button
          [id]="'save-images'"
          [type]="'submit'"
          (click)="save()"
          [isDisabled]="!hasChanges"
          [text]="cmsTextProvider.shared.save"
          [style]="'primary'"></aw-button>
      </div>
    </div>
    <div
      [formGroup]="filterForm"
      class="mb-4 flex justify-between gap-4"
      [attr.data-testid]="'texts' | appendTestId: 'filter'">
      <aw-search-bar
        formControlName="search"
        [placeholder]="cmsTextProvider.allImages.searchPlaceholder">
      </aw-search-bar>

      <div class="flex gap-2">
        <aw-button
          [id]="'delete-selected-images'"
          [style]="'tertiary'"
          (click)="markCheckedImagesForDeletion()"
          [type]="'button'"
          [isFullWidth]="false"
          [isDisabled]="anyCheckboxIsChecked()">
          <span
            class="material-symbols-rounded pr-2"
            [class.text-error-main]="!anyCheckboxIsChecked()"
            [class.text-standard-text-disabled]="anyCheckboxIsChecked()">
            delete
          </span>

          <span
            class="h-full"
            [class.text-error-main]="!anyCheckboxIsChecked()"
            [class.text-standard-text-disabled]="anyCheckboxIsChecked()">
            {{ cmsTextProvider.shared.delete }}
          </span>
        </aw-button>
        <aw-button
          [id]="'upload'"
          (click)="uploader.click()"
          [type]="'button'"
          [style]="'tertiary'"
          [isFullWidth]="false"
          [isDisabled]="imageStore.isLoading()">
          <span
            class="material-symbols-rounded pr-2"
            [class.text-primary-main]="!imageStore.isLoading()"
            [class.text-standard-text-disabled]="imageStore.isLoading()">
            upload
          </span>

          <span
            class="h-full"
            [class.text-primary-main]="!imageStore.isLoading()"
            [class.text-standard-text-disabled]="imageStore.isLoading()">
            {{ cmsTextProvider.shared.upload }}
          </span>
        </aw-button>
      </div>
    </div>
  </div>

  <div class="flex items-center">
    <div class="flex w-full flex-col items-start gap-2">
      <div
        class="relative w-full"
        (dragenter)="onDragEnter($event)"
        (dragleave)="onDragLeave($event)"
        (dragover)="onDragOver($event)"
        (drop)="onDrop($event)">
        <aw-table
          [isLoading]="imageStore.isLoading()"
          id="ticket-table"
          [defaultPageSize]="20"
          [data]="filteredImages"
          [header]="header"
          [columns]="columns"
          [hiddenColumns]="hiddenColumns"
          density="comfortable"
          tone="subtle"
          rowFlow="nowrap"
          (pageChange)="filterForm.updateValueAndValidity()"
          class="w-full">
          <ng-template #header let-sortBy="sortBy">
            <aw-table-header
              cellName="checkbox"
              [formGroup]="checkboxAllImages"
              class="w-42"
              [attr.data-testid]="'images' | appendTestId: 'select-all'">
              <aw-checkbox
                [id]="'select-all-images'"
                formControlName="checkbox" />
            </aw-table-header>
            <aw-table-header
              cellName="thumbnail"
              class="w-full"
              [attr.data-testid]="'images' | appendTestId: 'thumbnail'">
            </aw-table-header>
            <aw-table-header
              cellName="fileName"
              [sortParams]="{
                attribute: 'fileName',
                compare: imageNameFilter,
              }"
              class="w-full overflow-hidden"
              [attr.data-testid]="'images' | appendTestId: 'header-fileName'"
              (onSort)="sortBy($event)">
              {{ cmsTextProvider.allImages.imageDescription }}
            </aw-table-header>
            <aw-table-header
              cellName="createdAt"
              [sortParams]="{
                attribute: 'createdAt',
                compare: imageCreationDateFilter,
              }"
              class="w-full"
              [attr.data-testid]="'images' | appendTestId: 'header-createdAt'"
              (onSort)="sortBy($event)">
              {{ cmsTextProvider.shared.uploadedAt }}
            </aw-table-header>
            <aw-table-header
              cellName="usage"
              [sortParams]="{
                attribute: 'usage',
                compare: imageUsageFilter,
              }"
              class="w-full"
              [attr.data-testid]="'images' | appendTestId: 'header-usage'"
              (onSort)="sortBy($event)">
              {{ cmsTextProvider.allImages.usage }}
            </aw-table-header>
            <aw-table-header
              cellName="actions"
              class="w-full overflow-hidden"
              [attr.data-testid]="'images' | appendTestId: 'actions'">
            </aw-table-header>
          </ng-template>
          <ng-template #columns let-data="data" let-index="index">
            <ng-container [formGroup]="indicateFormGroup(data)">
              <aw-table-cell
                cellName="checkbox"
                class="group flex"
                [attr.data-testid]="
                  'images' | appendTestId: 'fileName-' + data.id
                ">
                <aw-checkbox
                  [id]="'checkbox-' + data.filename"
                  formControlName="isChecked" />
              </aw-table-cell>
              <aw-table-cell
                cellName="thumbnail"
                class="group flex w-full items-center justify-between"
                [attr.data-testid]="
                  'images' | appendTestId: 'thumbnail-' + data.id
                ">
                <img
                  [src]="getPreviewPath(data)"
                  class="h-12 w-24 cursor-pointer object-cover"
                  alt="Image Preview" />
              </aw-table-cell>
              <aw-table-cell
                cellName="fileName"
                class="w-full"
                [attr.data-testid]="
                  'images' | appendTestId: 'fileName-' + data.id
                ">
                {{ data.filename + '.' + data.fileExtension }}
              </aw-table-cell>
              <aw-table-cell
                cellName="createdAt"
                class="group flex w-full"
                [attr.data-testid]="
                  'images' | appendTestId: 'createdAt-' + data.id
                ">
                {{ data.createdAt | date: DATE_FORMAT }}
              </aw-table-cell>
              <aw-table-cell
                cellName="usage"
                class="group flex w-full justify-between py-2 hover:bg-[#E4EEF8]">
                {{ getUsage(data) }}
              </aw-table-cell>
              <aw-table-cell
                cellName="actions"
                class="group flex justify-end"
                [attr.data-testid]="
                  'images' | appendTestId: 'actions-' + data.id
                ">
                <div class="flex gap-4">
                  <span
                    class="material-symbols-rounded cursor-pointer"
                    (click)="openImageInDialog(data)"
                    >open_in_full</span
                  >
                  <div class="group relative">
                    <span
                      class="material-symbols-rounded icon-outline"
                      [class.text-error-main]="!hasUsage(data)"
                      [class.text-standard-text-disabled]="hasUsage(data)"
                      [class.cursor-pointer]="!hasUsage(data)"
                      [class.cursor-not-allowed]="hasUsage(data)"
                      [attr.aria-disabled]="hasUsage(data)"
                      (click)="
                        hasUsage(data) ? null : markImageForDeletion(data)
                      ">
                      delete
                    </span>

                    @if (hasUsage(data)) {
                      <span
                        class="border-standard-outline text-standard-text-primary pointer-events-none absolute right-0 bottom-full z-10 mb-1 hidden w-64 rounded-md border bg-white px-2 py-1 text-xs shadow-sm group-hover:block">
                        {{ cmsTextProvider.allImages.alreadyInUse }}
                      </span>
                    }
                  </div>
                </div>
              </aw-table-cell>
            </ng-container>
          </ng-template>
        </aw-table>
        @if (showOverlay) {
          <div
            class="bg-standard-hover-main pointer-events-none absolute inset-0 z-50 flex flex-col items-center justify-center gap-2 rounded-sm border border-solid transition-opacity"
            [style.border-image-source]="'repeating-linear-gradient(45deg, #4e5256 0 8px, transparent 8px 16px)'"
            [style.border-image-slice]="'1'"
            [style.border-image-repeat]="'round'">
            <p class="text-lg">
              <span class="material-symbols-rounded">upload</span>
            </p>
            <p class="text-lg">
              {{ cmsTextProvider.allImages.uploadHint }}
            </p>
            <p class="text-lg">{{ cmsTextProvider.allImages.maxSize }} xx MB</p>
          </div>
        }
      </div>
    </div>
  </div>

  <input
    [attr.data-testid]="'upload-file' | appendTestId: 'input'"
    [id]="'image-upload'"
    type="file"
    hidden
    #uploader
    [multiple]="false"
    accept="image/tiff, image/png, image/gif, image/jpeg, image/svg+xml, image/webp, image/x-icon, .svg, .ico"
    (change)="selectFilesEvent($event)" />
}
